import React from 'react';
import GenericErrorUI from '../../../components/common/GenericErrorUI';
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';
import SalesTargetCreateModalSF from '../../../components/superUser/account/SalesTargetCreateModalSF';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import CardUI from '../../../widgets/layout/CardUI';
import SelectUI from '../../../widgets/input/SelectUI';
import SalesTargetNavUI from './SalesTargetNavUI';
import SalesTargetUpdateModalSF from '../../../components/superUser/account/SalesTargetUpdateModalSF';

const SalesTargetListPageUI = ({ context, errorList, salesTargetList,
  salesChannelList, userIdList, monthList, yearList, selectedTarget,
  createSalesTargetMode, onCreateSalesTargetClick, onCreateSalesTargetCancel,
  updateSalesTargetMode, onUpdateSalesTargetClick, onUpdateSalesTargetCancel,
  month, onMonthChange, channel, onChannelChange, originator, onOriginatorChange,
  onFilterChange, filteredSalesTargetList,onDownloadClick,userIdSList,
  onRefreshClick,totals }) =>

(

  <SuperUserHomePageUI
    context={context} className='pg_su_ld' topnav='accounts' dimension='w1600'
    centered={!filteredSalesTargetList && !errorList} page='salesTargets'
  >
    {
      (!filteredSalesTargetList && !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {filteredSalesTargetList &&
      <LRTableActionsUI
        location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <IconButtonUI icon='icon-plus' onClick={onCreateSalesTargetClick} />
            <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
            <span className='g_m_left_100 g_large'><b>Sales Targets</b></span>
          </span>
        }
        right={
          <span className='g_flex_h'>
            <div className='g_m_right_100' style={{ width: '200px' }}>
              <SelectUI
                selectedKey={month}
                optionList={monthList}
                onChange={(option) =>  onFilterChange(option, 'month')}
                placeholder='Month'
              />
            </div>
            <div className='g_m_right_100' style={{ width: '200px' }}>
              <SelectUI
                selectedKey={channel}
                optionList={salesChannelList}
                onChange={(option) => onFilterChange(option, 'channel')}
                placeholder='Sales Channel'
              />
            </div>
            <div className='g_m_right_100' style={{ width: '200px' }}>
              <SelectUI
                selectedKey={originator}
                optionList={userIdSList}
                onChange={(option) => onFilterChange(option, 'originator')}
                placeholder='Originator'
              />
            </div>
          </span>
        }
      />
    }
    {filteredSalesTargetList && <SalesTargetNavUI page='report' />}
    {
      filteredSalesTargetList && filteredSalesTargetList.length === 0 && (
        <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No Sales Targets' />
      )
    }
    {
      filteredSalesTargetList && filteredSalesTargetList.length > 0 && (
        <div>
          <CardUI className='g_m_top_100 g_normal'>
            <table border={1} style={{ borderCollapse: 'collapse', width: '100%' }}>
              <thead>
                <tr>
                  <th >Name</th>
                  <th >Month</th>
                  <th >Sales Channel</th>
                  <th>Contact(s) Target</th>
                  <th>Contact(s) Achieved</th>
                  <th>Lead(s) Target</th>
                  <th>Lead(s) Achieved</th>
                  <th>Customer(s) Target</th>
                  <th>Customer(s) Achieved</th>
                  <th >Disb. Target</th>
                  <th >Disb. Achieved</th>
                  <th> Update Target</th>
                </tr>
              </thead>
              <tbody>
                {filteredSalesTargetList.map((salesTarget, index) => (
                  <tr key={index}>
                    <td className=''>
                    <span>{salesTarget.firstName} {salesTarget.lastName}</span>
                     </td>
                    <td className='g_text_center amt'>{salesTarget.month}</td>
                    <td className='g_text_center amt'>{salesTarget.channel}</td>
                    <td className='g_text_center amt g_col_grey'>{salesTarget.noOfContactsF}</td>
                    <td className='g_text_center amt g_col_black'>{salesTarget.contactsAchievedF}</td>
                    <td className='g_text_center amt g_col_grey'>{salesTarget.newLeadTargetF}</td>
                    <td className='g_text_center amt g_col_black'>{salesTarget.newLeadAchievedF}</td>
                    <td className='g_text_center amt g_col_grey'>{salesTarget.numberOfCustomersF}</td>
                    <td className='g_text_center amt g_col_black'>{salesTarget.customersAchievedF}</td>
                    <td className='g_text_center amt g_col_grey'>{salesTarget.newDisbTargetF}</td>
                    <td className='g_text_center amt g_col_black'>{salesTarget.newDisbAchievedF}</td>
                    <span className="icon icon-pencil g_m_left_200 g_cursor_pointer g_muted" sales-target-id={salesTarget.salesTargetId}
                      onClick={onUpdateSalesTargetClick}></span>
                  </tr>
                ))}
              </tbody>
              <tfoot>
              <tr>
                <td className='g_text_center'><b>Totals</b></td>
                <td className='g_text_center amt'></td>
                <td className='g_text_center amt'></td>
                <td className='g_text_center amt g_col_grey'><b>{totals.totalNoOfContactsF}</b></td>
                <td className='g_text_center amt g_col_black'><b>{totals.totalContactsAchievedF}</b></td>
                <td className='g_text_center amt g_col_grey'><b>{totals.totalNewLeadTargetF}</b></td>
                <td className='g_text_center amt g_col_black'><b>{totals.totalNewLeadAchievedF}</b></td>
                <td className='g_text_center amt g_col_grey'><b>{totals.totalNumberOfCustomersF}</b></td>
                <td className='g_text_center amt g_col_black'><b>{totals.totalCustomersAchievedF}</b></td>
                <td className='g_text_center amt g_col_grey'><b>{totals.totalNewDisbTargetF}</b></td>
                <td className='g_text_center amt g_col_black'><b>{totals.totalNewDisbAchievedF}</b></td>
              </tr>
            </tfoot>

            </table>
          </CardUI>
        </div>
      )
    }

    <SalesTargetCreateModalSF context={context} salesTargetCreateMode={createSalesTargetMode}
      onCreateSalesTargetCancel={onCreateSalesTargetCancel} onRefreshClick={onRefreshClick}
      userIdList={userIdList} salesChannelList={salesChannelList} monthList={monthList} yearList={yearList}
    />

    <SalesTargetUpdateModalSF context={context} salesTargetUpdateMode={updateSalesTargetMode}
      onUpdateSalesTargetCancel={onUpdateSalesTargetCancel} onRefreshClick={onRefreshClick}
      userIdList={userIdList} monthList={monthList} yearList={yearList} salesTarget={selectedTarget}
    />
  </SuperUserHomePageUI>
);

export default SalesTargetListPageUI;
